@if (headerItems.length > 0) {
@let isValidUser = isValidUser$ | async;
@let isAuthenticated = isAuthenticated$ | async;
<admiralty-header alt="UK Hydrographic Office"
                  [ngClass]="isValidUser || isAuthenticated ? '' : 'header'"
                  (titledClicked)="dashboardNavigate()"
                  [logoImgUrl]="header.logoImgUrl"
                  [logoLinkUrl]="header.logoLinkUrl"
                  [logoAltText]="header.logoAltText"
                  [headerTitle]="header.title">
  @if (getIsAuthedInternalUser$ | async) {
    @for (item of headerItems; track item.title) {
      <admiralty-header-menu-item [hidden]="!isValidUser"
                                  [menuTitle]="item.title"
                                  (menuItemClick)="navigate(item.routerLink)"
                                  [slot]="'items'"></admiralty-header-menu-item>
    }
  }
  @if (getIsAuthedExternalUser$ | async) {
    @for (item of headerItems; track item.title) {
      <admiralty-header-menu-item [hidden]="!isValidUser && (isUduUser$ | async)"
                                  [menuTitle]="item.title"
                                  (menuItemClick)="navigate(item.routerLink)"
                                  [slot]="'items'"></admiralty-header-menu-item>
    }
  }
  @if (isAuthenticated) {
  <admiralty-header-profile [isSignedIn]="isAuthenticated"
                            id="profileButton"
                            (yourAccountClicked)="onAccountClicked($event)"
                            (signOutClicked)="logout($event)"
                            [signedInText]="(fullname | async)"
                            class="profile"
                            slot="profile"></admiralty-header-profile>
  }
</admiralty-header>
}
<main class="is-12-fullhd m-0">
<!--  <div [ngClass]="isLoggedIn()? 'mt-2' : ''">-->
<!--    <admiralty-phase-banner phase="beta" class="pt-2" [ngClass]="!isLoggedIn()? 'banner' : ''" [link]="sendEmail()">-->
<!--    </admiralty-phase-banner>-->
<!--  </div>-->
  <router-outlet></router-outlet>
</main>
<admiralty-footer imageSrc="../assets/UKHO_stacked_logo.svg">
  @for (item of footerItems; track item.title) {
    @if (item.href !== null) {
      <admiralty-link [href]="item.href" [newTab]="item.newTab">{{ item.title }}</admiralty-link>
    } @else {
      <admiralty-link [newTab]="item.newTab" (click)="navigate(item.routerLink)">{{ item.title }}</admiralty-link>
    }
  }
</admiralty-footer>
